(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1993],{

/***/ 93088:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regional-meetup",
      function () {
        return __webpack_require__(79349);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 31719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Container(_param) {
    var children = _param.children, fluid = _param.fluid, classNameInput = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "fluid",
        "className"
    ]);
    var className = "PingCAPContainer";
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, classNameInput, (_obj = {}, _defineProperty(_obj, "".concat(className, "-fluid"), fluid), _defineProperty(_obj, "".concat(className, "-normal"), !fluid), _obj))
    }, rest, {
        children: children
    }));
};


/***/ }),

/***/ 80344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31719);

/* harmony default export */ __webpack_exports__["Z"] = (_Container__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 66327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75302);

var useIsSmallScreen = function() {
    var breakpoint = antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].useBreakpoint */ .ZP.useBreakpoint();
    return {
        isSmallScreen: !breakpoint.md,
        breakpoint: breakpoint
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSmallScreen);


/***/ }),

/***/ 79349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/duration.js
var duration = __webpack_require__(1646);
var duration_default = /*#__PURE__*/__webpack_require__.n(duration);
// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(61980);
// EXTERNAL MODULE: ./src/components/Container/index.ts
var Container = __webpack_require__(80344);
// EXTERNAL MODULE: ./src/hooks/useIsSmallScreen.js
var useIsSmallScreen = __webpack_require__(66327);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/regional-meetup/Header/index.styled.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: #f7f8f9;\n  padding: 64px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      .slick-list {\n        width: calc(100% - 24px) !important;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: 3rem;\n\n      .slick-slide {\n        padding-right: 0;\n      }\n\n      .slick-dots {\n        margin: 0 auto;\n        bottom: -32px;\n\n        li {\n          margin: 3px 8px;\n\n          &,\n          button {\n            ",
        "\n          }\n\n          &.slick-active {\n            &,\n            button {\n              ",
        "\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  .slick-dots {\n    li {\n      margin: 8px 3px;\n\n      &,\n      button {\n        ",
        "\n        background: ",
        ";\n        border-radius: 3px;\n      }\n\n      &.slick-active {\n        &,\n        button {\n          ",
        "\n          background: ",
        ";\n        }\n      }\n    }\n  }\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  //width: 100%;\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 30px;\n  line-height: 42px;\n  color: #890707;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #2c2c2c;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
var Carousel = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), function(props) {
    return !props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, mixins/* size */.dp("6px", "40px"), polished_esm/* rgba */.m4(colors.F2, 0.1), mixins/* size */.dp("6px", "50px"), polished_esm/* rgba */.m4(colors.F2, 0.3), function(props) {
    return props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), mixins/* size */.dp("40px", "6px"), mixins/* size */.dp("50px", "6px"));
});
var CarouselItem = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var Title = styled_components_browser_esm/* default.h1 */.ZP.h1(_templateObject6());
var Description = styled_components_browser_esm/* default.p */.ZP.p(_templateObject7());
var Actions = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(_templateObject8());
var JoinButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "primary"
})(_templateObject9());
var NominateButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "link"
})(_templateObject10());

;// CONCATENATED MODULE: ./src/pages/regional-meetup/data/广州.jpg
/* harmony default export */ var _ = ({"src":"https://img1.tidb.net/_next/static/media/广州.23af60c1.jpg","height":1350,"width":2400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAL/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIEEQMVIUFh/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIRAxEAPwCNg8zmxzgwljpIYeDdGu79RER0j//Z"});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/data/天津.jpg
/* harmony default export */ var data_ = ({"src":"https://img1.tidb.net/_next/static/media/天津.27a06470.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAAABgMBAAAAAAAAAAAAAAAAAgMREhMBBEGB/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAwDAQACEQMRAD8AjRNdpJ6qmVDKQe60zyz2Lt4AABVnwv/Z"});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/data/武汉.jpg
/* harmony default export */ var regional_meetup_data_ = ({"src":"https://img1.tidb.net/_next/static/media/武汉.cd6a63a0.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAACAQMFAAAAAAAAAAAAAAABAgAEERIDBSExUf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQBR/9oADAMBAAIRAxEAPwCXXbxjqgJR06tkwFl4AB6t5ERJMxdv/9k="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/data/济南.jpg
/* harmony default export */ var pages_regional_meetup_data_ = ({"src":"https://img1.tidb.net/_next/static/media/济南.3d0c039b.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAACAgIDAQAAAAAAAAAAAAABAwACBAUGEyGx/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABgRAAMBAQAAAAAAAAAAAAAAAAABMREh/9oADAMBAAIRAxEAPwCJn8k2mNr2vTk2WGv6guvlaggE/IiICW0V8h//2Q=="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/data/石家庄.jpg
/* harmony default export */ var src_pages_regional_meetup_data_ = ({"src":"https://img1.tidb.net/_next/static/media/石家庄.5edea962.jpg","height":720,"width":1280,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgEFAAAAAAAAAAAAAAACAwABEQQFEiEx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAVEQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEQMRAD8Antv1rHqpjFp5C7FEIYLHV+xESeHr/9k="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/data/index.tsx








var joinUrl = "https://forms.pingcap.com/f/regional-meetup-organizer";
var recommendUrl = "https://asktug.com/t/topic/664366";
// 顶部轮播图
var headerImages = [
    {
        image: _
    },
    {
        image: data_
    },
    {
        image: regional_meetup_data_
    },
    {
        image: pages_regional_meetup_data_
    },
    {
        image: src_pages_regional_meetup_data_
    }, 
];
var applyDescription = "\u6210\u4E3A\u5730\u533A\u7EC4\u7EC7\u8005\u53EF\u4EAB\u6709\u54EA\u4E9B\u793E\u533A\u798F\u5229\uFF1F";
// 社区专属福利
var advantages = [
    "\u5730\u533A\u7EC4\u7EC7\u8005\u4E13\u5C5E\u5FBD\u7AE0",
    "\u793E\u533A ID \u5B9A\u5236\u5496\u5561\u676F",
    "\u4F18\u5148\u9080\u8BF7\u53C2\u4E0E DevCon ",
    "TiDB \u6700\u65B0\u8BFE\u7A0B\u7684\u5C1D\u9C9C\u673A\u4F1A",
    "500 \u79EF\u5206\u548C\u7ECF\u9A8C\u503C",
    "\u7EC4\u7EC7\u8005\u798F\u5229\u5927\u793C\u5305", 
];
// Q&A
var questionAndAnswer = [
    {
        Q: "\u6211\u60F3\u7EC4\u7EC7\u4E00\u573A\u5730\u533A\u6D3B\u52A8\uFF0C\u4F46\u8FD8\u6CA1\u6709\u627E\u5230\u5408\u9002\u7684\u8BB2\u5E08\u600E\u4E48\u529E\uFF1F",
        A: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "\u6B22\u8FCE\u6765 asktug \u8BBA\u575B\uFF08asktug.com\uFF09\u53D1\u5E16\u4ECB\u7ECD\u4F60\u7684\u6D3B\u52A8\u8BA1\u5212\uFF0C\u5E76\u62DB\u52DF\u5730\u533A\u5206\u4EAB\u5609\u5BBE\uFF0C\u793E\u533A\u4E5F\u4F1A\u5728\u5404\u793E\u7FA4\u6E20\u9053\u534F\u52A9\u63A8\u5E7F\u5BFB\u627E\u5B9D\u85CF\u8BB2\u5E08~\u6BCF\u4E00\u4E2A\u79EF\u6781\u53C2\u4E0E\u5730\u533A\u4EA4\u6D41\u5E76\u5206\u4EAB\u7684\u540C\u5B66\u6211\u4EEC\u90FD\u6709\u4E30\u539A\u7684\u793E\u533A\u793C\u5305\u8D60\u9001\u5594"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "\u5E16\u5B50\u53EF\u53C2\u8003\uFF1A",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                            href: "https://asktug.com/t/topic/662777"
                        }),
                        "\uFF08\u6B66\u6C49\u5609\u5BBE\u62DB\u52DF\u5E16\uFF09"
                    ]
                })
            ]
        })
    },
    {
        Q: "\u5730\u533A\u7EC4\u7EC7\u6D3B\u52A8\u6B22\u8FCE\u4EC0\u4E48\u6837\u7684\u6280\u672F\u5206\u4EAB\uFF1F\uFF08\u8BDD\u9898\u5BA1\u6838\u7684\u6807\u51C6\uFF09",
        A: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u603B\u7ED3\u201C\u6B22\u8FCE\u5B9E\u8DF5/\u539F\u7406\u7C7B\u5206\u4EAB\uFF1B\u62D2\u63A5\u5E26\u8D27\u5E7F\u544A\u201D\uFF0C\u80FD\u5E2E\u52A9\u5927\u5BB6\u907F\u5751\uFF0C\u201C\u6DA8\u59FF\u52BF\u201D\u7684\u5B9D\u85CF\u5E72\u8D27\u6700\u6B22\u8FCE\uD83D\uDC4F\uD83C\uDFFB"
            })
        })
    },
    {
        Q: "\u793E\u533A\u7ED9\u4E88\u5730\u533A\u7EC4\u7EC7\u591A\u5C11\u8D44\u6E90\u6765\u7B79\u5907\u6D3B\u52A8\uFF0C\u793E\u533A\u662F\u5426\u6709\u8FD0\u8425\u53EF\u4EE5\u7ED9\u4E88\u652F\u6301\uFF1F",
        A: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u9996\u5148\uFF0C\u793E\u533A\u8FD0\u8425\u4E00\u5B9A\u662F\u975E\u5E38\u53EF\u9760\u7684\u7AD9\u5728\u7EC4\u7EC7\u8005\u8EAB\u8FB9\u7684\uFF01\u9488\u5BF9\u62A5\u540D\u4EBA\u6570\uFF0C\u793E\u533A\u4F1A\u7ED9\u4E88\u5BF9\u5E94\u62A5\u540D\u4EBA\u6570\u7684\u8D44\u6E90\u652F\u6301\uFF0C\u5305\u62EC\u573A\u5730\u3001\u96F6\u552E\u8336\u6B47\u3001\u6D3B\u52A8\u7269\u6599\u51C6\u5907\u7B49\u5728\u5185\u7684\u7269\u8D44\u652F\u6301\u3002\uFF08\u53C2\u8003\uFF1A\u5982\u62A5\u540D\u4EBA\u6570\u572820\u4EBA\u4EE5\u4E0A\u5219\u7ED9\u4E882000-5000\u5143\u4E0D\u7B49\u7684\u7269\u8D44\u652F\u6301\uFF09\u3002"
            })
        })
    },
    {
        Q: "\u6D3B\u52A8\u7B79\u5907\u4E2D\uFF0C\u4E34\u65F6\u9047\u5230\u75AB\u60C5\u5F71\u54CD\uFF0C\u6216\u8005\u8BB2\u5E08\u6CA1\u6CD5\u6765\u4E86\u600E\u4E48\u529E\uFF1F",
        A: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u5982\u679C\u4E34\u65F6\u9047\u5230\u75AB\u60C5\u7BA1\u63A7\uFF0C\u5EFA\u8BAE\u4E0E\u62A5\u540D\u7684\u5C0F\u4F19\u4F34\u4EE5\u53CA\u5206\u4EAB\u5609\u5BBE\u6C9F\u901A\u662F\u5426\u9700\u8981\u5EF6\u671F\uFF0C\u4E00\u8D77\u5EF6\u671F\u65E5\u671F\u53EF\u4EE5\u901A\u8FC7\u6295\u7968\u7684\u65B9\u5F0F\u9009\u62E9\u3002"
            })
        })
    },
    {
        Q: "\u6211\u60F3\u7EC4\u7EC7\u5730\u533A\u6D3B\u52A8\uFF0C\u4F46\u600E\u4E48\u67E5\u770B\u6211\u6240\u5728\u7684\u5730\u533A\u662F\u5426\u5DF2\u6709\u5730\u533A\u7EC4\u7EC7\u8005\uFF1F",
        A: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\u6BCF\u4E3E\u529E\u4E00\u671F\u5730\u533A\u6280\u672F\u4EA4\u6D41\u6D3B\u52A8\uFF0C\u6211\u4EEC\u90FD\u5C06\u5728\u5730\u533A\u6D3B\u52A8\u9875\u9762\u53CA\u65F6\u66F4\u65B0\u76F8\u5173\u4FE1\u606F\uFF0C\u5982\u679C\u8BE5\u5730\u533A\u5DF2\u4E3E\u529E\u8FC7\u5730\u533A\u4EA4\u6D41\u6D3B\u52A8\uFF0C\u4F60\u53EF\u4EE5\u901A\u8FC7\u7AD9\u5185\u4FE1\u4E0E\u5730\u533A\u7EC4\u7EC7\u8005\u8054\u7CFB\uFF0C\u5171\u540C\u5546\u8BAE\u4E0B\u4E00\u573A\u6D3B\u52A8\u8BA1\u5212\u5594"
            })
        })
    }, 
];

;// CONCATENATED MODULE: ./src/pages/regional-meetup/Header/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var Header = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = _objectWithoutProperties(props, [
        "data"
    ]);
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Container, _objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                gutter: [
                    32,
                    64
                ],
                wrap: true,
                justify: "space-between",
                align: "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        sm: 24,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: data.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                    children: data.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                            href: joinUrl,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinButton, {
                                                children: "\uD83D\uDE4B\u200D \u6211\u8981\u6210\u4E3A\u5730\u533A\u7EC4\u7EC7\u8005"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                            href: recommendUrl,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NominateButton, {
                                                children: "\u6211\u8981\u63D0\u540D TA"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        sm: 24,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                            $isSmallScreen: isSmallScreen,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, {
                                autoplay: true,
                                dotPosition: isSmallScreen ? "bottom" : "right",
                                children: headerImages.map(function(value) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: value.image.src,
                                            alt: ""
                                        })
                                    }, value.image.src);
                                })
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var regional_meetup_Header = (Header);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlaySquareOutlined.js + 1 modules
var PlaySquareOutlined = __webpack_require__(61727);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ClockCircleOutlined.js + 1 modules
var ClockCircleOutlined = __webpack_require__(24019);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlayCircleOutlined.js + 1 modules
var PlayCircleOutlined = __webpack_require__(74842);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js + 1 modules
var UpOutlined = __webpack_require__(48115);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(80882);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlayCircleFilled.js + 1 modules
var PlayCircleFilled = __webpack_require__(67874);
;// CONCATENATED MODULE: ./src/pages/regional-meetup/VideoRecord/index.styled.ts
function index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function index_styled_templateObject() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  padding: 32px 16px;\n"
    ]);
    index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function index_styled_templateObject1() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 48px;\n"
    ]);
    index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function index_styled_templateObject2() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  max-width: 480px;\n  img {\n    width: 100%;\n  }\n"
    ]);
    index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function index_styled_templateObject3() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 32px;\n  line-height: 45px;\n  /* identical to box height */\n  color: #2c2c2c;\n"
    ]);
    index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function index_styled_templateObject4() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 34px;\n  /* identical to box height */\n  color: #000000;\n"
    ]);
    index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function index_styled_templateObject5() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  padding: 6px 16px;\n  background: #eaedf0;\n  border: 1px solid #e1e3e9;\n  border-radius: 6px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #8f8f8f;\n"
    ]);
    index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function index_styled_templateObject6() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #565656;\n"
    ]);
    index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function index_styled_templateObject7() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #565656;\n"
    ]);
    index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function index_styled_templateObject8() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #565656;\n"
    ]);
    index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function index_styled_templateObject9() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 36px;\n"
    ]);
    index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function index_styled_templateObject10() {
    var data = index_styled_taggedTemplateLiteral([
        "\n    //  display: none;\n    //\n  "
    ]);
    index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 54px;\n  //",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  padding-top: 32px;\n  text-align: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = index_styled_taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = index_styled_taggedTemplateLiteral([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  padding: 2px 12px;\n  background: #eaedf0;\n  border: 1px solid #e1e3e9;\n  border-radius: 6px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 17px;\n  /* identical to box height */\n  color: #8f8f8f;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 4px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: #2c2c2c;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 4px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 17px;\n  /* identical to box height */\n  color: #565656;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 17px;\n  /* identical to box height */\n  color: #565656;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = index_styled_taggedTemplateLiteral([
        "\n      box-shadow: inset 0 0 0 8px ",
        ";\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  background-size: 100% 100%;\n  //padding-bottom: 62.8%;\n  width: ",
        "px;\n  height: ",
        "px;\n  background-image: url(",
        ");\n  border-color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  font-size: 2rem;\n  color: ",
        ";\n  opacity: 75%;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n\n  border-radius: 2rem;\n  box-shadow: 2px 2px 12px 0px rgb(0 0 0 / 25%);\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}





var VideoRecord_index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(index_styled_templateObject());
var Recommend = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(index_styled_templateObject1());
var RecommendStart = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject2());
var index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject3());
var RecommendTitle = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject4());
var RecommendTag = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject5());
var RecommendPeople = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject6());
var RecommendSummary = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject7());
var RecommendDate = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject8());
var RecommendAction = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject9());
var List = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject11(), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject10())));
var More = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12());
var VideoCover = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13());
var Info = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14());
var InfoTag = styled_components_browser_esm/* default.div */.ZP.div(_templateObject15());
var InfoTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject16());
var InfoPeople = styled_components_browser_esm/* default.div */.ZP.div(_templateObject17());
var InfoDate = styled_components_browser_esm/* default.div */.ZP.div(_templateObject18());
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(_templateObject19(), colors.C4);
var VideoBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject21(), function(param) {
    var $width = param.$width;
    return $width;
}, function(param) {
    var $height = param.$height;
    return $height;
}, function(param) {
    var $src = param.$src;
    return $src;
}, colors.M1, function(props) {
    return !props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject20(), colors.M1);
});
var VideoPlayButton = styled_components_browser_esm/* default.div */.ZP.div(_templateObject22(), mixins/* flexCenter */._7(), mixins/* flexVerticalCenter */.VL());
var VideoPlayIcon = (0,styled_components_browser_esm/* default */.ZP)(PlayCircleFilled/* default */.Z)(_templateObject23(), colors.C4, colors.M2);

;// CONCATENATED MODULE: ./src/pages/regional-meetup/VideoRecord/index.tsx
function VideoRecord_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VideoRecord_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VideoRecord_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function VideoRecord_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = VideoRecord_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function VideoRecord_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var VideoRecord = function(props) {
    //function SectionTitle(props: IProps) {
    var videoRecordItems = props.data.videoRecordItems, rest = VideoRecord_objectWithoutProperties(props, [
        "data"
    ]);
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoRecord_index_styled_Container, VideoRecord_objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Title, {
                children: "\u7CBE\u9009\u6D3B\u52A8\u73B0\u573A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Recommend, {
                size: 32,
                wrap: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendStart, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                            href: "https://www.bilibili.com/video/".concat(videoRecordItems[0].bvid),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: videoRecordItems[0].videoCoverImage.src,
                                alt: videoRecordItems[0].title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendTag, {
                                    children: videoRecordItems[0].region
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: "https://www.bilibili.com/video/".concat(videoRecordItems[0].bvid),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendTitle, {
                                    children: videoRecordItems[0].title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendPeople, {
                                children: videoRecordItems[0].authorName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaySquareOutlined/* default */.Z, {}),
                                            " ",
                                            videoRecordItems[0].playCount
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockCircleOutlined/* default */.Z, {}),
                                            " ",
                                            videoRecordItems[0].createDatetime
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                    href: "https://space.bilibili.com/86485707",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                        type: "primary",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutlined/* default */.Z, {}),
                                        children: "\u67E5\u770B\u6240\u6709\u89C6\u9891"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                wrap: true,
                gutter: [
                    36,
                    36
                ],
                children: videoRecordItems.slice(1, showMore ? undefined : 7).map(function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                            size: 10,
                            align: "start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCover, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCoverItem, {
                                        url: "https://www.bilibili.com/video/".concat(value.bvid),
                                        videoCoverImage: value.videoCoverImage,
                                        //duration={value.duration}
                                        width: 160,
                                        height: 100
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTag, {
                                                children: value.region
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                            href: "https://www.bilibili.com/video/".concat(value.bvid),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                                children: value.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPeople, {
                                            children: value.authorName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaySquareOutlined/* default */.Z, {}),
                                                        " ",
                                                        value.playCount
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockCircleOutlined/* default */.Z, {}),
                                                        " ",
                                                        value.createDatetime
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, value.bvid);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(More, {
                children: showMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                    type: "link",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {}),
                    onClick: function() {
                        return setShowMore(false);
                    },
                    children: "\u6536\u8D77"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                    type: "link",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {}),
                    onClick: function() {
                        return setShowMore(true);
                    },
                    children: "\u5C55\u5F00\u66F4\u591A"
                })
            })
        ]
    }));
};
/* harmony default export */ var regional_meetup_VideoRecord = (VideoRecord);
//function VideoCoverLarge({ url, videoCoverImage }) {
//  const { isSmallScreen } = useIsSmallScreen();
//  return (
//    <Styled.VideoBox $isSmallScreen={isSmallScreen} $src={encodeURI(videoCoverImage.src)}>
//      <Styled.VideoPlayButton>
//        <Anchor href={url}>
//          <Styled.VideoPlayIcon color="white" height="48px" />
//        </Anchor>
//      </Styled.VideoPlayButton>
//    </Styled.VideoBox>
//  );
//}
function VideoCoverItem(param) {
    var url = param.url, videoCoverImage = param.videoCoverImage, width = param.width, height = param.height;
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBox, {
        $isSmallScreen: isSmallScreen,
        $src: encodeURI(videoCoverImage.src),
        $width: width,
        $height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayButton, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                href: url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayIcon, {
                    color: "white",
                    height: "48px"
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/pages/regional-meetup/HowToJoin/index.styled.ts
function HowToJoin_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HowToJoin_index_styled_templateObject() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  padding: 32px 0;\n"
    ]);
    HowToJoin_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject1() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  background: linear-gradient(180deg, #d30000 -55.7%, rgba(252, 227, 0, 0) 100%);\n  padding: 20px;\n"
    ]);
    HowToJoin_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject2() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  background: linear-gradient(180deg, #f7f8f9 0%, rgba(247, 248, 249, 0) 129.56%);\n  border-radius: 6px;\n  padding: 32px 0;\n"
    ]);
    HowToJoin_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject3() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  //background-color: #FFFFFF;\n"
    ]);
    HowToJoin_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject4() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        ""
    ]);
    HowToJoin_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject5() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 32px;\n  line-height: 45px;\n  /* identical to box height */\n  color: #2c2c2c;\n"
    ]);
    HowToJoin_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject6() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 48px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #565656;\n"
    ]);
    HowToJoin_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject7() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 22px;\n"
    ]);
    HowToJoin_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject8() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        ""
    ]);
    HowToJoin_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject9() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 64px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 28px;\n  /* identical to box height */\n  color: #2c2c2c;\n"
    ]);
    HowToJoin_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HowToJoin_index_styled_templateObject10() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n    padding: 16px;\n  "
    ]);
    HowToJoin_index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function index_styled_templateObject11() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  padding: 64px 32px;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  ",
        ";\n"
    ]);
    index_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function index_styled_templateObject12() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n    border-right: 1px solid #e0e0e0;\n  "
    ]);
    index_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function index_styled_templateObject13() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n    border-bottom: 1px solid #e0e0e0;\n  "
    ]);
    index_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function index_styled_templateObject14() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  img {\n    width: 100%;\n  }\n"
    ]);
    index_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function index_styled_templateObject15() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        ""
    ]);
    index_styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function index_styled_templateObject16() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  //background: #f9d34f;\n  width: 28px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  color: #fff;\n  font-weight: 700;\n"
    ]);
    index_styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function index_styled_templateObject17() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height */\n  color: #565656;\n"
    ]);
    index_styled_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function index_styled_templateObject18() {
    var data = HowToJoin_index_styled_taggedTemplateLiteral([
        ""
    ]);
    index_styled_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}




var HowToJoin_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(HowToJoin_index_styled_templateObject());
var ContainerOuter = styled_components_browser_esm/* default.div */.ZP.div(HowToJoin_index_styled_templateObject1());
var ContainerInner = styled_components_browser_esm/* default.div */.ZP.div(HowToJoin_index_styled_templateObject2());
var Main = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(HowToJoin_index_styled_templateObject3());
var index_styled_Header = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(HowToJoin_index_styled_templateObject4());
var HowToJoin_index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(HowToJoin_index_styled_templateObject5());
var index_styled_Description = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(HowToJoin_index_styled_templateObject6());
var Action = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(HowToJoin_index_styled_templateObject7());
var Image = styled_components_browser_esm/* default.div */.ZP.div(HowToJoin_index_styled_templateObject8());
var ApplyDescription = styled_components_browser_esm/* default.p */.ZP.p(HowToJoin_index_styled_templateObject9());
var Prize = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(index_styled_templateObject11(), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(HowToJoin_index_styled_templateObject10())));
var GiftsImage = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject14(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject12())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject13())));
var Advantage = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(index_styled_templateObject15());
var AdvantageIcon = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject16());
var AdvantageText = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject17());
var index_styled_List = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(index_styled_templateObject18());

;// CONCATENATED MODULE: ./src/pages/regional-meetup/HowToJoin/photo.png
/* harmony default export */ var photo = ({"src":"https://img1.tidb.net/_next/static/media/photo.3c22a663.png","height":1220,"width":2100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAM1BMVEWddXWPZXC3iYe1j5CzhYPHo565l6OkY2Sxd3tMaXHMqqendW7fxcu5lJKQcnmYdn6KXGxLD2a3AAAAEXRSTlOamI6elHGjhYUAl5SjsnCrYTgSPgcAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAoSURBVAiZY2Bg5mFgZONlZWBiYeBmYePnY+BgZ2fn4GAUYOBi5QQDAA31AOTf36unAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/HowToJoin/gifts.png
/* harmony default export */ var gifts = ({"src":"https://img1.tidb.net/_next/static/media/gifts.1bc2baa9.png","height":698,"width":1882,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAANlBMVEW4ytTavLjFxc2Uq7Dj5/X5+fTY4OTv9fjdxr+tsbCFpubp7O6wsr2gkpFEZ1C4xOcWXt+rxPKl/bS0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVQImWPgZmAXZOFhYmVg5mMQ4Ofk5WBg42TnYmHnYAQACkUAvX1FXioAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/HowToJoin/vector.png
/* harmony default export */ var vector = ({"src":"https://img1.tidb.net/_next/static/media/vector.294c04c1.png","height":31,"width":30,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEX50k740k750k7500750k7500740k/40k/50063bbjKAAAACHRSTlP81OWh4MUwXlnvF3YAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAuSURBVAiZLYpBDgAgCMOqA93/X2xAelnSjthN4AGwQwYj32yhI1PKFWrnvD75ACq4ASZycHESAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/HowToJoin/index.tsx
function HowToJoin_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function HowToJoin_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HowToJoin_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var HowToJoin = function(props) {
    //function SectionTitle(props: IProps) {
    var rest = _extends({}, props);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToJoin_index_styled_Container, HowToJoin_objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOuter, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerInner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Header, {
                            wrap: true,
                            justify: "center",
                            align: "middle",
                            gutter: [
                                32,
                                32
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                    sm: 24,
                                    md: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToJoin_index_styled_Title, {
                                            children: "\u5982\u4F55\u6210\u4E3A\u5730\u533A\u7EC4\u7EC7\u8005\uFF1F"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Description, {
                                            children: "\u5730\u533A\u7EC4\u7EC7\u8005\u662F\u4E3B\u5BFC\u5730\u533A\u6280\u672F\u4EA4\u6D41\u6D3B\u52A8\u7684\u91CD\u8981\u529B\u91CF\uFF0C\u901A\u8FC7\u7EC4\u7EC7\u5730\u533A\u6D3B\u52A8\u8FDE\u63A5\u793E\u533A\u4E0E\u6280\u672F\u540C\u4EC1\uFF0C\u6210\u4E3A\u5730\u533A\u7EC4\u7EC7\u8005\u4E0D\u4EC5\u80FD\u83B7\u5F97\u793E\u533A\u4E13\u5C5E\u8363\u8A89\uFF0C\u4E5F\u53EF\u4EE5\u901A\u8FC7\u5730\u533A\u4EA4\u6D41\u5EFA\u7ACB\u6216\u57F9\u517B\u5BF9\u5916\u6C9F\u901A\u80FD\u529B\uFF0C\u8DDF\u4E0A\u6280\u672F\u53D1\u5C55\u7684\u6F6E\u6D41\uFF0C\u548C\u5FD7\u540C\u9053\u5408\u7684\u6280\u672F\u4EBA\u4E00\u8D77\u611F\u53D7\u5F00\u6E90\u793E\u533A\u7684\u9B45\u529B\u3002"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: joinUrl,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                    type: "primary",
                                                    children: "\uD83D\uDE4B \u7ACB\u5373\u7533\u8BF7"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    sm: 24,
                                    md: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), HowToJoin_objectSpread({}, photo, {
                                        alt: "\u5730\u533A\u7EC4\u7EC7\u8005\u7167\u7247\u5899"
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyDescription, {
                            children: applyDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Prize, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                gutter: [
                                    32,
                                    32
                                ],
                                align: "middle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        sm: 24,
                                        md: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftsImage, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), HowToJoin_objectSpread({}, gifts))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        sm: 24,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                                            direction: "vertical",
                                            size: 32,
                                            children: advantages.slice(0, 3).map(function(value) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Advantage, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageIcon, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), HowToJoin_objectSpread({}, vector))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageText, {
                                                            children: value
                                                        })
                                                    ]
                                                }, value);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        sm: 24,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                                            direction: "vertical",
                                            size: 32,
                                            children: advantages.slice(3, 6).map(function(value) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Advantage, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageIcon, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), HowToJoin_objectSpread({}, vector))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageText, {
                                                            children: value
                                                        })
                                                    ]
                                                }, value);
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var regional_meetup_HowToJoin = (HowToJoin);

// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/index.styled.ts
function SharedContent_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SharedContent_index_styled_templateObject() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n    padding: 32px 16px;\n  "
    ]);
    SharedContent_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject1() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  padding: 64px 0;\n  ",
        ";\n  background: #f7f8f9;\n"
    ]);
    SharedContent_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject2() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        ""
    ]);
    SharedContent_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject3() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  text-align: center;\n  font-weight: 500;\n  font-size: 32px;\n  line-height: 45px;\n  /* identical to box height */\n  color: #2c2c2c;\n"
    ]);
    SharedContent_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject4() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 54px;\n  .swiper-slide {\n    height: 100%;\n  }\n  .swiper-pagination-bullet {\n    width: 32px;\n    border-radius: 4px;\n    &-active {\n      background-color: #777;\n    }\n  }\n"
    ]);
    SharedContent_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject5() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        ""
    ]);
    SharedContent_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject6() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  padding: 36px 24px;\n  background: #ffffff;\n  border: 1px solid #d5d5d5;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n"
    ]);
    SharedContent_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject7() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  height: 56px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 28px;\n  /* identical to box height */\n  color: #000000;\n"
    ]);
    SharedContent_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject8() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  height: ",
        "px;\n  margin-top: 16px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: ",
        "px;\n  color: #565656;\n"
    ]);
    SharedContent_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject9() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 1px;\n  background-color: #e0e0e0;\n  margin-top: 32px;\n  margin-bottom: 24px;\n"
    ]);
    SharedContent_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject10() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  //width: 120px;\n  //height: 120px;\n  //img {\n  //  width: 100%;\n  //  height: 100%;\n  //}\n"
    ]);
    SharedContent_index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject11() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #2c2c2c;\n"
    ]);
    SharedContent_index_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject12() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  height: 36px;\n"
    ]);
    SharedContent_index_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SharedContent_index_styled_templateObject13() {
    var data = SharedContent_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 24px;\n"
    ]);
    SharedContent_index_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var SharedContent_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject1(), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(SharedContent_index_styled_templateObject())));
var index_styled_Main = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(SharedContent_index_styled_templateObject2());
var SharedContent_index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject3());
var Content = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject4());
var SharedContent_index_styled_List = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(SharedContent_index_styled_templateObject5());
var index_styled_Card = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject6());
var CardTitle = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject7(), mixins/* lineClamp */.Sf(2));
var lineClamp = 3;
var lineHeight = 22;
var CardDescription = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject8(), mixins/* lineClamp */.Sf(lineClamp), lineClamp * lineHeight, lineHeight);
var CardSplitLine = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject9());
//const avatarSizePx = 120
var CardAuthorAvatar = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject10());
var CardAuthorInfo = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject11());
var CardIcons = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject12());
var CardMore = styled_components_browser_esm/* default.div */.ZP.div(SharedContent_index_styled_templateObject13());

;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/index.tsx
function SharedContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SharedContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SharedContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SharedContent_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = SharedContent_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SharedContent_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



// Import Swiper React components

// import required modules



var SharedContent = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = SharedContent_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedContent_index_styled_Container, SharedContent_objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Main, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedContent_index_styled_Title, {
                    children: "\u4F18\u8D28\u5206\u4EAB\u5185\u5BB9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        pagination: {
                            clickable: true
                        },
                        breakpoints: {
                            "@0.00": {
                                slidesPerView: 1,
                                spaceBetween: 10
                            },
                            "@0.75": {
                                slidesPerView: 2,
                                spaceBetween: 20
                            },
                            "@1.00": {
                                slidesPerView: 2,
                                spaceBetween: 40
                            },
                            "@1.50": {
                                slidesPerView: 3,
                                spaceBetween: 50
                            }
                        },
                        modules: [
                            swiper_esm/* Pagination */.tl
                        ],
                        children: data.sharedContentCards.map(function(value) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedContent_Card, {
                                    data: value
                                })
                            }, value.title);
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var regional_meetup_SharedContent = (SharedContent);
var SharedContent_Card = function(props) {
    //function SectionTitle(props: IProps) {
    var data = props.data, rest = SharedContent_objectWithoutProperties(props, [
        "data"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            paddingBottom: 64,
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Card, SharedContent_objectSpread({}, rest, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                    children: data.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescription, {
                    children: data.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSplitLine, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAuthorAvatar, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", SharedContent_objectSpread({}, data.avatarImage, {
                        width: 120,
                        height: 120,
                        alt: data.authorName
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardAuthorInfo, {
                    children: [
                        data.authorName,
                        " | ",
                        data.authorTitle
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcons, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                        children: data.iconImages.map(function(value) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                title: value.alt,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", SharedContent_objectSpread({}, value, {
                                    width: 36,
                                    height: 36
                                }))
                            }, value.src);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMore, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                        href: "/u/".concat(data.username),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            type: "primary",
                            children: "TA \u7684\u66F4\u591A\u5206\u4EAB"
                        })
                    })
                })
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./src/pages/regional-meetup/QandA/index.styled.ts
function QandA_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function QandA_index_styled_templateObject() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  padding: 72px 0;\n"
    ]);
    QandA_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject1() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  text-align: center;\n  font-weight: 500;\n  font-size: 32px;\n  line-height: 45px;\n  /* identical to box height */\n  color: #2c2c2c;\n"
    ]);
    QandA_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject2() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 54px;\n"
    ]);
    QandA_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject3() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  padding-top: 32px;\n  text-align: center;\n"
    ]);
    QandA_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject4() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        ""
    ]);
    QandA_index_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject5() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        ""
    ]);
    QandA_index_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject6() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  width: 28px;\n  height: 28px;\n  background: #ff6d78;\n  border-radius: 2px;\n  line-height: 28px;\n  text-align: center;\n  color: #fff;\n"
    ]);
    QandA_index_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject7() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 28px;\n  /* identical to box height */\n  color: #2c2c2c;\n"
    ]);
    QandA_index_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject8() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        ""
    ]);
    QandA_index_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject9() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  width: 28px;\n  height: 28px;\n  background: #4f54c1;\n  border-radius: 2px;\n  line-height: 28px;\n  text-align: center;\n  color: #fff;\n"
    ]);
    QandA_index_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function QandA_index_styled_templateObject10() {
    var data = QandA_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  color: #2c2c2c;\n"
    ]);
    QandA_index_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var QandA_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(QandA_index_styled_templateObject());
var QandA_index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(QandA_index_styled_templateObject1());
var index_styled_Content = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(QandA_index_styled_templateObject2());
var index_styled_More = styled_components_browser_esm/* default.div */.ZP.div(QandA_index_styled_templateObject3());
var Item = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(QandA_index_styled_templateObject4());
var Question = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(QandA_index_styled_templateObject5());
var QuestionIcon = styled_components_browser_esm/* default.div */.ZP.div(QandA_index_styled_templateObject6());
var QuestionText = styled_components_browser_esm/* default.div */.ZP.div(QandA_index_styled_templateObject7());
var Answer = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(QandA_index_styled_templateObject8());
var AnswerIcon = styled_components_browser_esm/* default.div */.ZP.div(QandA_index_styled_templateObject9());
var AnswerText = styled_components_browser_esm/* default.div */.ZP.div(QandA_index_styled_templateObject10());

;// CONCATENATED MODULE: ./src/pages/regional-meetup/QandA/index.tsx
function QandA_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function QandA_extends() {
    QandA_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return QandA_extends.apply(this, arguments);
}
function QandA_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            QandA_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var QandA = function(props) {
    //function SectionTitle(props: IProps) {
    var rest = QandA_extends({}, props);
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)();
    var collapse = isSmallScreen.isSmallScreen && !showMore;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QandA_index_styled_Container, QandA_objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                    lg: 16,
                    md: 20,
                    sm: 24,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QandA_index_styled_Title, {
                            children: "Q&A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Content, {
                            size: 54,
                            direction: "vertical",
                            children: questionAndAnswer.slice(1, collapse ? 2 : undefined).map(function(value) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                    size: 16,
                                    direction: "vertical",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Question, {
                                            align: "start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionIcon, {
                                                    children: "Q"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionText, {
                                                    children: value.Q
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Answer, {
                                            align: "start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerIcon, {
                                                    children: "A"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerText, {
                                                    children: value.A
                                                })
                                            ]
                                        })
                                    ]
                                }, value.Q);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_More, {
                            children: collapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "primary",
                                ghost: true,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {}),
                                onClick: function() {
                                    return setShowMore(true);
                                },
                                children: "\u5C55\u5F00\u5176\u4ED6\u95EE\u9898\u4E0E\u7B54\u6848"
                            })
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var regional_meetup_QandA = (QandA);

;// CONCATENATED MODULE: ./src/pages/regional-meetup/JoinNow/index.styled.ts
function JoinNow_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function JoinNow_index_styled_templateObject() {
    var data = JoinNow_index_styled_taggedTemplateLiteral([
        "\n  padding: 48px 0;\n  background: #2b0000;\n"
    ]);
    JoinNow_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JoinNow_index_styled_templateObject1() {
    var data = JoinNow_index_styled_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 34px;\n  text-align: center;\n  color: #fff;\n"
    ]);
    JoinNow_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JoinNow_index_styled_templateObject2() {
    var data = JoinNow_index_styled_taggedTemplateLiteral([
        "\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    JoinNow_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var JoinNow_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(JoinNow_index_styled_templateObject());
var JoinNow_index_styled_Title = styled_components_browser_esm/* default.div */.ZP.div(JoinNow_index_styled_templateObject1());
var index_styled_Action = styled_components_browser_esm/* default.div */.ZP.div(JoinNow_index_styled_templateObject2());

;// CONCATENATED MODULE: ./src/pages/regional-meetup/JoinNow/index.tsx
function JoinNow_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function JoinNow_extends() {
    JoinNow_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return JoinNow_extends.apply(this, arguments);
}
function JoinNow_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            JoinNow_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var JoinNow = function(props) {
    //function SectionTitle(props: IProps) {
    var rest = JoinNow_extends({}, props);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinNow_index_styled_Container, JoinNow_objectSpread({}, rest, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinNow_index_styled_Title, {
                    children: "\u73B0\u5728\u7ACB\u523B\u62A5\u540D\u7EC4\u7EC7\u4E00\u573A\u6D3B\u52A8\u5427\uFF01"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Action, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                        href: joinUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            type: "primary",
                            children: "\uD83D\uDE4B \u6211\u8981\u6210\u4E3A\u5730\u533A\u7EC4\u7EC7\u8005"
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var regional_meetup_JoinNow = (JoinNow);

;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/data/avatars/xfworld.png
/* harmony default export */ var xfworld = ({"src":"https://img1.tidb.net/_next/static/media/xfworld.a7d53a55.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVMaXHa19mLjI1oaGgAAQEqLC3a19m4ubuxsbNbW1r+//+Zmpvd4uV6fH7Fxce/v8GKjI/KyMm5urtzdnXDxMbU1NYcHh7V1dcZFxa1sa/HyMvSzM+Tmp7Y1demoZ+Ec2axsrXk5ed9f4LjpfAXAAAAGnRSTlMATP37/v0s/ET8Dy6BDlye53rkWdqhaab+ihEF3IwAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABCSURBVAiZHctHEoAgEADBQVBYE+aA2f8/0pJbXxpQa5sB+HCd1kF9a5G3qZgfvaQ2OMYjMRFq+zEA5W6ki62Y+hw+bcYC3e2L0GoAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/data/avatars/hey-hoho.png
/* harmony default export */ var hey_hoho = ({"src":"https://img1.tidb.net/_next/static/media/hey-hoho.df26c77b.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVMaXHJys13hqK1u8bJys26ur60tLfLyclKXoGorrpAT2c7T3E9UHP///89Tm1DU3A2RmdcYXrX1tawsbWZnaKLj5RNZI/OrKCBj6u+npO4ur1CWIB4gpMvRnB3a2ezpKSBdnOKl7HCs7G7PJxtAAAAGnRSTlMAZvf9/j6CK/n+I2dNGBj8ZWBghoaB+vr6+oS4waUAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABESURBVAiZFctVFoAgFEDBSwnYHQ97/4v0OP8DuHHyAJncpyhwIttirWeQeL3GKrIYnjibHr8fek26gqJJIZR/y9uuhg90QgMgfbJGrQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/data/avatars/Jellybean.png
/* harmony default export */ var Jellybean = ({"src":"https://img1.tidb.net/_next/static/media/Jellybean.5e99a77b.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVMaXHw17jCoovr0rRCRkvZv6JGSlIyNz+0p52fi3blzK5wZ1owNjs4OjnewaD/4rz/37mxnoaFdG/u07Tt1bdYUlSDYVLlzK51T0SCe3WxoJLpz7JBQ0jFrZQrLzKThHTTuJuYemj33Lw5LdFTAAAAHHRSTlMA/vz8YUX9/Qz9R00ugaGmXJ42inrk/uf7+9ojhFuB5AAAAAlwSFlzAAALEgAACxIB0t1+/AAAAEVJREFUCJkVy0cSgCAQAMEBgQXMOWH8/yMt+96A7YcdoA3PkUVojrBoNXvqO0xaZZHqkiTra8lPceI2D6WkNHZ/K4zx8AFxTgMGN751pQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/data/avatars/bian_cheng_yuan_yuan.png
/* harmony default export */ var bian_cheng_yuan_yuan = ({"src":"https://img1.tidb.net/_next/static/media/bian_cheng_yuan_yuan.fd777383.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEVMaXHNzMyam5rc3Nu8vb3k5OTZ2dmxsbHCw8Lj5OTX1tWQkZClpaX7+vuysrIhISHn5ubV1dX////b2djz8/NOTk62trbm5ePw8fH5+fm1tbWkpaXW1tbnnYckAAAAGXRSTlMA/P3++w6CRv78pP0jNudZ5NouTYFpnlz+2jsjwAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAEJJREFUCJkVy0cSwCAMALGlxQbSO+X/78xEdwEyDCPA3UsxAo+6GPscSOrf6KuQTK7VqnC45rVtwFmyXae/7dcS4ANddgKhdXNcxwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/data/avatars/a_fu_chris.png
/* harmony default export */ var a_fu_chris = ({"src":"https://img1.tidb.net/_next/static/media/a_fu_chris.e3e52d9e.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAZlBMVEVMaXEUDw3Rv7ni1NH48/Lp187q3tvq3NjgzsXs4eBPSUjr4eG/qJr56urz5+eEe3vayL4vJyPm19Hv4uHayb/j0cnUwbPbycAlIB7Csarl1c43MzKpf2xaUE3w4d337ey7pZt3bm3CTQItAAAAHnRSTlMA/fr9Dob6Sf46/Qcu5NpZI2mh53pcS57++qb++/4WX/xXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAQ0lEQVQImRXLxRHAIAAAwcMl7g6k/yYz2f8Cq5l7gM0Xbx0syt8yT5rTyifa7BjTsV8qB1wqIqa2AlPE24S/1UOn4QNz0wM4EaoYLgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/data/avatars/zhang_tian.png
/* harmony default export */ var zhang_tian = ({"src":"https://img1.tidb.net/_next/static/media/zhang_tian.ca074dd2.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAZlBMVEVMaXGtcGKTbmKugGtDSE9vXlNnSj+nq6FjWVpBOjVzZVzWnIY3NjGojnmId2ddT0NSTEpfXWBiVlH//+gxNj9xYlWRi4TBvbhMTE6Yko2Abl6wrqtRUVR8bmCZgHGHf3phVlC2j4B64kveAAAAHHRSTlMA/P38Uw79RPz++v6hXJ6maYEuBzZMI4rk2ud6tSEDuwAAAAlwSFlzAAALEgAACxIB0t1+/AAAAERJREFUCJkVy8cRgCAAAMEDyZhzANT+m3Tc/wJ2u1aANt93WKApwbl8ajovYxHSUvsqVuK1qGSMT8cEg3vSPv9t7JWGD3U/Ax6/5Vz8AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/regional-meetup/SharedContent/data/index.tsx







var sharedContents = {
    //xfworld
    xfworld: {
        title: "\u6211\u548C TiDB \u7684\u6545\u4E8B - \u6211\u4EEC\u7EC8\u4F1A\u5728\u5E73\u884C\u4E16\u754C\u76F8\u9047",
        description: "\u6BCF\u4E2A\u4EBA\u90FD\u4F1A\u6709\u81EA\u5DF1\u7684\u65B9\u5411\uFF0C\u6216\u591A\u6216\u5C11\u90FD\u4F1A\u53D7\u5DE5\u4F5C\u3001\u751F\u6D3B\u3001\u68A6\u60F3\u7B49\u7B49\u7684\u5F71\u54CD\uFF0C\u751A\u81F3\u88AB\u5DE6\u53F3\uFF0C\u6DF1\u9677\u5176\u4E2D\u4E0D\u77E5\u5982\u4F55\u9009\u62E9\u3002",
        authorName: "\u8096\u98DE",
        authorTitle: "\u5609\u91CC\u5927\u901A\u7269\u6D41 \u67B6\u6784\u5E08",
        avatarImage: xfworld
    },
    //hey-hoho
    "hey-hoho": {
        title: "\u6211\u548CTiDB\u7684\u6545\u4E8B | \u6BEB\u65E0\u51C6\u5907\u5730\u4E0D\u671F\u800C\u9047\uFF0C\u5374\u60F3\u8BF4\u4E0E\u4F60\u76F8\u9047\u597D\u5E78\u8FD0",
        description: "\u5199\u8FD9\u7BC7\u6587\u7AE0\u66F4\u591A\u7684\u662F\u50CF\u4E00\u7BC7\u5E74\u7EC8\u56DE\u5FC6\uFF0C\u6625\u8282\u4E4B\u524D\u4E00\u76F4\u6709\u8FD9\u4E48\u4E2A\u60F3\u6CD5\u6765\u56DE\u987E\u8FD9\u4E00\u5E74\u6211\u548CTIDB\u5947\u5999\u7684\u7F18\u5206\uFF0C\u4F46\u662F\u603B\u88AB\u4FD7\u52A1\u7F20\u8EAB\u6401\u7F6E\u5230\u73B0\u5728\uFF0C\u76F4\u5230\u8868\u59B9\u524D\u6BB5\u65F6\u95F4\u7EA6\u7A3F\uFF0C\u6211\u77E5\u9053\u4E0D\u5F97\u4E0D\u5F00\u59CB\u4E86\u3002",
        authorName: "\u4F55\u50B2",
        authorTitle: "\u795E\u5DDE\u6570\u7801 \u9AD8\u7EA7\u540E\u7AEF\u5F00\u53D1\u5DE5\u7A0B\u5E08",
        avatarImage: hey_hoho
    },
    //Jellybean
    Jellybean: {
        title: "TiDB \u51B7\u70ED\u5B58\u50A8\u5206\u79BB\u89E3\u51B3\u65B9\u6848",
        description: "TiDB 6.0 \u7684 Placement Rules in SQL \u529F\u80FD\u6B63\u5F0F GA\uFF0C\u7528\u6237\u901A\u8FC7 SQL \u914D\u7F6E\u6570\u636E\u5728 TiKV \u96C6\u7FA4\u4E2D\u7684\u653E\u7F6E\u4F4D\u7F6E\uFF0C\u53EF\u4EE5\u5BF9\u6570\u636E\u8FDB\u884C\u76F4\u63A5\u7684\u7BA1\u7406\uFF0C\u6EE1\u8DB3\u4E0D\u540C\u7684\u4E1A\u52A1\u573A\u666F\u9700\u8981\u3002",
        authorName: "\u674E\u6587\u6770",
        authorTitle: "\u7F51\u6613\u6E38\u620F\u8BA1\u8D39\u7EC4 TiDB \u8D1F\u8D23\u4EBA",
        avatarImage: Jellybean
    },
    //边城元元
    边城元元: {
        title: "TiKV & TiFlash \u52A0\u901F\u590D\u6742\u4E1A\u52A1\u67E5\u8BE2",
        description: "\u4F7F\u7528 TiKV \u548C TiFlash \u53EF\u4EE5\u52A0\u901F\u590D\u6742\u67E5\u8BE2\uFF0C\u672C\u6587\u5C06\u4ECB\u7ECD\u5B9E\u73B0\u8DEF\u5F84",
        authorName: "\u8FB9\u57CE\u5143\u5143",
        authorTitle: "\u77F3\u5BB6\u5E84\u5730\u533A\u6D3B\u52A8\u7EC4\u7EC7\u8005",
        avatarImage: bian_cheng_yuan_yuan
    },
    //阿福Chiris
    阿福Chiris: {
        title: "\u8FD9\u4E00\u5E74\uFF0C\u6211\u548C TiDB \u7684\u6545\u4E8B",
        description: "\u5957\u7528\u73B0\u5728\u6587\u96C5\u7684\u8BF4\u6CD5\uFF0C2021 Dev Conf \u662F\u6545\u4E8B\u5F00\u59CB\u7684\u5730\u65B9\uFF0C\u53BB\u5E74\u6211\u9634\u5DEE\u9633\u9519\u7684\u8DDF\u7740\u670B\u53CB\u53C2\u52A0\u4E86 TiDB Dev Conf\uFF0C\u90A3\u65F6\u5019\u65B0\u51A0\u8FD8\u4E0D\u53EB\u5965\u5BC6\u514B\u620E\uFF0C\u5F88\u591A\u4EBA\u5929\u771F\u7684\u4EE5\u4E3A\uFF0C\u8FC7\u4E862021\u5E74\u590F\u5929\uFF0C\u65B0\u51A0\u5C31\u7ED3\u675F\u4E86\u3002\u626F\u8FDC\u4E86\uFF0C\u56DE\u5230\u6B63\u9898\uFF0C2021\u5E747\u670824\u65E5\uFF0C\u5750\u7740\u9AD8\u94C1\uFF0C\u6211\u6765\u5230\u4E86 Dev Conf \u4F1A\u573A\uFF0C\u62FF\u7740 \u201C\u4E89\u505AContributor\u201D \u7684\u724C\u5B50\uFF0C\u5047\u88C5\u81EA\u5DF1\u4E5F\u662F\u4E00\u679A SQL BOY\u3002",
        authorName: "\u963F\u798Fchris",
        authorTitle: "\u6D4E\u5357\u5730\u533A\u6D3B\u52A8\u7EC4\u7EC7\u8005",
        avatarImage: a_fu_chris
    },
    //数据小黑
    数据小黑: {
        title: "\u547D\u91CC\u6709\u65F6\u7EC8\u987B\u6709--\u8BB0\u4E0ETiDB\u7684\u4E00\u6B21\u6B21\u64E6\u80A9\u800C\u8FC7",
        description: "19\u5E74\u6211\u53F8\u59D4\u6258\u6211\u4E00\u4E2A\u4EFB\u52A1\uFF0C\u627E\u4E00\u4E2A\u6570\u636E\u5E93\uFF0C\u80FD\u591F\u627F\u62C5\u8D77\u5386\u53F2\u6570\u636E\u660E\u7EC6\u67E5\u8BE2\uFF0C\u8981\u6C42\u6709\u591A\u5C11\u6570\u636E\u88C5\u591A\u5C11\u6570\u636E\uFF0C\u4EE5\u8F83\u9AD8\u7684\u5E76\u53D1\uFF0C\u4EE5\u53CA\u7528\u6237\u80FD\u591F\u5FCD\u53D7\u7684\u65F6\u95F4\uFF083\u79D2\uFF09\u8FD4\u56DE\u3002\u5F53\u65F6\u56E2\u961F\u91CC\u9762\u6709\u4E2A\u8001\u5927\u54E5\uFF0C\u5BF9\u6BD4\u4E86\u51E0\u4E2A\u6570\u636E\u5E93\uFF0C\u6709Citus\u3001YugaByteDB\u3001TiDB\u7B49\u7B49\uFF0CTiDB\u662F\u6700\u65E9\u5F00\u59CB\u6D4B\u8BD5\uFF0C\u4E5F\u662F\u6700\u65E9\u653E\u5F03\u7684...",
        authorName: "\u5F20\u7530",
        authorTitle: "\u6D6A\u6F6E\u96C6\u56E2 \u67B6\u6784\u5E08",
        avatarImage: zhang_tian
    }
};

;// CONCATENATED MODULE: ./src/pages/regional-meetup/VideoRecord/data/index.tsx
var videoRecords = {
    BV1w5411i7L3: {
        region: "\u5317\u4EAC\u7AD9",
        authorName: "\u6234\u6D9B | PingCAP \u4E2D\u56FD\u4E1A\u52A1\u89E3\u51B3\u65B9\u6848\u6280\u672F\u90E8\u603B\u7ECF\u7406"
    },
    BV1o5411v7Sf: {
        region: "\u5317\u4EAC\u7AD9",
        authorName: "\u5F90\u793C\u4F73 | PingCAP \u5317\u7F8E\u5927\u5BA2\u6237\u67B6\u6784\u5E08"
    },
    BV1NW4y1A7AG: {
        region: "\u5317\u4EAC\u7AD9",
        authorName: "\u5F20\u70E8 | TiDB \u5185\u6838\u4EA7\u54C1\u7ECF\u7406"
    },
    BV1ce411v7EW: {
        region: "\u5317\u4EAC\u7AD9",
        authorName: "\u9EC4\u6F2B\u7EC5 | TiDB \u793E\u533A\u8FD0\u8425"
    },
    BV1FT4y1n7fn: {
        region: "\u5317\u4EAC\u7AD9",
        authorName: "\u4EE3\u6653\u78CA | \u77E5\u4E4E\u6570\u636E\u5E93\u8D1F\u8D23\u4EBA"
    },
    BV1ie411U7wQ: {
        region: "\u5317\u4EAC\u7AD9",
        authorName: "\u5218\u5F3A | \u4F5C\u4E1A\u5E2E\u6570\u636E\u5E93\u67B6\u6784\u5E08\uFF0C\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u8D1F\u8D23\u4EBA"
    },
    BV1BC4y1K75s: {
        region: "\u4E0A\u6D77\u7AD9",
        authorName: "\u859B\u6653\u521A | \u6B27\u51B6\u4E91\u5546\u9996\u5E2D\u6570\u636E\u5E93\u4E13\u5BB6"
    },
    BV1Fe411z7L3: {
        region: "\u4E0A\u6D77\u7AD9",
        authorName: "\u848B\u660E | \u524D\u6DD8\u5B9D DBA"
    },
    BV1si4y1h7xF: {
        region: "\u4E0A\u6D77\u7AD9",
        authorName: "\u738B\u519B | 5\u5E74+ PingCAPer"
    },
    BV1se411z73s: {
        region: "\u4E0A\u6D77\u7AD9",
        authorName: "Eason \u848B\u7693\u6960 | TiDB \u5185\u6838\u4EA7\u54C1\u7ECF\u7406\u8D1F\u8D23\u4EBA"
    },
    BV1sV4y1W7dg: {
        region: "\u5E7F\u5DDE\u7AD9",
        //title: '网易互娱在 TiDB SaaS 运维平台的建设',
        //description: '',
        //videCoverImage: cover1Image,
        authorName: "\u7530\u7EF4\u7E41 | \u7F51\u6613\u4E92\u5A31\u8D44\u6DF1\u6570\u636E\u5E93\u5DE5\u7A0B\u5E08"
    },
    BV1nG41147Ng: {
        region: "\u5E7F\u5DDE\u7AD9",
        //title: 'TiDB 冷热存储分离方案',
        //description: '',
        //videCoverImage: cover2Image,
        authorName: "\u674E\u6587\u6770 | \u7F51\u6613\u6E38\u620F\u8BA1\u8D39\u7EC4 TiDB \u8D1F\u8D23\u4EBA"
    },
    BV1Ba41157Wp: {
        region: "\u5E7F\u5DDE\u7AD9",
        //title: 'TiKV 架构及原理介绍',
        //description: '',
        //videCoverImage: cover3Image,
        authorName: "\u9093\u529B\u94ED | PingCAP \u9AD8\u7EA7\u5F00\u53D1\u5DE5\u7A0B\u5E08"
    },
    BV1hg411r7iv: {
        region: "\u5E7F\u5DDE\u7AD9",
        //title: 'Demo Show-mini OSSInsight',
        //description: '',
        //videCoverImage: cover4Image,
        authorName: "\u9648\u971C | TiDB \u793E\u533A\u9AD8\u7EA7\u5DE5\u7A0B\u5E08"
    },
    BV1vT41177V6: {
        region: "\u6B66\u6C49\u7AD9",
        //title: '实战 | 如何做好一次 TiDB POC 测试',
        //description: '',
        //videCoverImage: cover5Image,
        authorName: "\u4F55\u50B2 | \u795E\u5DDE\u6570\u7801  \u9AD8\u7EA7\u540E\u7AEF\u5F00\u53D1\u5DE5\u7A0B\u5E08"
    },
    BV1ja411M7LN: {
        region: "\u6B66\u6C49\u7AD9",
        //title: 'TiDB 开发操作的一些想法和展望',
        //description: '',
        //videCoverImage: cover6Image,
        authorName: "\u8096\u98DE | \u5609\u91CC\u5927\u901A\u7269\u6D41 \u67B6\u6784\u5E08"
    },
    BV1hW4y1U7tH: {
        region: "\u6D4E\u5357\u7AD9",
        //title: 'TiDB 介绍 & TiSpark 实践',
        //description: '',
        //videCoverImage: cover7Image,
        authorName: "\u5F20\u7530 | \u6D6A\u6F6E\u96C6\u56E2 \u67B6\u6784\u5E08"
    },
    BV14B4y1i76J: {
        region: "\u6D4E\u5357\u7AD9",
        //title: 'TiSpark + Hudi + Kyuubi 混合数据湖方案',
        //description: '',
        //videCoverImage: cover8Image,
        authorName: "\u8BB8\u65B0\u6D69 | \u4E07\u65B9\u6570\u636E"
    },
    BV1ZT41137fC: {
        region: "\u6D4E\u5357\u7AD9",
        //title: '运维视角下的 Linux 避坑指南',
        //description: '',
        //videCoverImage: cover9Image,
        authorName: "\u7C7B\u5EF6\u826F | PostgreSQL 14 \u6570\u636E\u5E93\u8F6F\u4EF6\u8D21\u732E\u8005"
    },
    BV1uZ4y1v7gg: {
        region: "\u6D4E\u5357\u7AD9",
        //title: 'Greenplum 的 MPP 特性分享及选型思考',
        //description: '',
        //videCoverImage: cover10Image,
        authorName: "\u82D1\u6CFD\u798F | TiDB \u793E\u533A\u7231\u597D\u8005"
    },
    BV1e34y1p7gL: {
        region: "\u6D4E\u5357\u7AD9",
        //title: '基于 Oracle DBSAT 的实践总结及思考',
        //description: '',
        //videCoverImage: cover11Image,
        authorName: "\u674E\u5174\u5E05 | \u5F88\u719F\u6089 Oracle \u7684DBA"
    },
    BV1uW4y1r73R: {
        region: "\u5929\u6D25\u7AD9",
        //title: 'MySQL 和 TiDB CDC 原理对比',
        //description: '',
        //videCoverImage: cover12Image,
        authorName: "\u66F9\u4E1C\u745C | TiDB \u5929\u6D25\u5730\u533A\u7EC4\u7EC7\u8005"
    },
    BV15W4y1S7YK: {
        region: "\u5929\u6D25\u7AD9",
        //title: 'MySQL MGR + 自研脚本实现高可用切换',
        //description: '',
        //videCoverImage: cover13Image,
        authorName: "\u674E\u5C0F\u950B | \u957F\u57CE\u6C7D\u8F66\u5F00\u53D1\u5DE5\u7A0B\u5E08"
    },
    BV13N4y1u7uf: {
        region: "\u5929\u6D25\u7AD9",
        //title: '新型数仓 Databend 的存储层设计',
        //description: '',
        //videCoverImage: cover14Image,
        authorName: "Xuanwo | \u5F00\u6E90\u4E3B\u4E49\u8005"
    }
};

;// CONCATENATED MODULE: ./src/pages/regional-meetup/index.page.tsx
function index_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function index_page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            index_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














dayjs_min_default().extend((duration_default()));
var title = "\u5730\u533A\u6D3B\u52A8";
var description = "TiDB \u5730\u533A\u6D3B\u52A8\u662F\u901A\u8FC7\u5404\u5730\u533A\u7EC4\u7EC7\u8005\u4E3E\u529E\u7684\u5730\u533A\u6280\u672F\u4EA4\u6D41\u6D3B\u52A8\uFF0C\u6BCF\u671F\u5730\u533A\u7EC4\u7EC7\u6D3B\u52A8\u4EE5\u201C\u8FDE\u63A5\u5730\u533A\u6280\u672F\u4EBA\uFF0C\u5206\u4EAB\u6280\u672F\u5B9E\u8DF5\u201D\u4E3A\u6838\u5FC3\u76EE\u7684\uFF0C\u76EE\u524D\u6211\u4EEC\u5DF2\u5728\u5929\u6D25\u3001\u77F3\u5BB6\u5E84\u3001\u6D4E\u5357\u3001\u6B66\u6C49\u3001\u5E7F\u5DDE\u7B49\u5730\u4E3E\u529E\u591A\u573A\u5730\u533A\u7EC4\u7EC7\u6D3B\u52A8\u3002";
var seo = {
    title: title,
    description: description,
    keywords: [
        "TiDB",
        "Meetup",
        "HTAP",
        "\u5730\u533A\u5206\u4EAB"
    ]
};
var RegionalMeetupPage = function(param) {
    var sharedContentFromServer = param.sharedContentFromServer, videoRecordsFromServer = param.videoRecordsFromServer;
    var sharedContentCards = Object.keys(sharedContentFromServer).map(function(username) {
        return index_page_objectSpread({
            username: username
        }, sharedContents[username], sharedContentFromServer[username]);
    });
    var videoRecordItems = Object.keys(videoRecords).map(function(bvid) {
        return index_page_objectSpread({
            bvid: bvid
        }, videoRecords[bvid], videoRecordsFromServer[bvid]);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: seo.title,
                description: seo.description,
                keyword: seo.keywords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(regional_meetup_Header, {
                data: {
                    title: title,
                    description: description
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(regional_meetup_VideoRecord, {
                data: {
                    videoRecordItems: videoRecordItems
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(regional_meetup_HowToJoin, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(regional_meetup_SharedContent, {
                data: {
                    sharedContentCards: sharedContentCards
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(regional_meetup_QandA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(regional_meetup_JoinNow, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var index_page = (RegionalMeetupPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5180,8019,9774,2888,179], function() { return __webpack_exec__(93088); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);